import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { MOUNT_INTENTS } from '../../utils/routeParamConstants';
import Utils from '../../utils';
import SSOLinksInterface from '../../api/SSOLinksInterface';
import { SSOLinksResponseKeys } from '../../api/Constants';
import audio from '../../utils/audio';
import PlayerInterface from '../../api/PlayerInterface';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import store from '../../state/store';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import ERROR_CODE from '../../utils/errorCodes';
import Logger from '../../lib/analytics/logger';
import { postGuestLogin } from '../../state/query/login';
import { getAffId } from '../../utils/getAffId';
import { isStar } from '../../utils/targetApplication';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';

var Start = /*#__PURE__*/function (_Component) {
  _inherits(Start, _Component);

  var _super = _createSuper(Start);

  function Start(props) {
    var _this;

    _classCallCheck(this, Start);

    _this = _super.call(this, props);
    _this.isRN = Utils.isReactNative();
    _this.checkRecoverPassRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var urlParams, id, token, platform, recoverRequest;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              urlParams = QueryParamsProxy.getAllParams();

              if (urlParams) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              id = urlParams.i;
              token = urlParams.t;
              platform = urlParams.platform;

              if (!(id && token && platform)) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return PlayerInterface.recoverPasswordTokenCheck({
                id: id,
                token: token
              });

            case 9:
              recoverRequest = _context.sent;

              if (!recoverRequest.success) {
                _this.setState({
                  showRecoverPass: {
                    visible: true,
                    invalid: true,
                    message: recoverRequest.error
                  }
                });
              } else {
                _this.setState({
                  showRecoverPass: {
                    visible: true,
                    invalid: false,
                    id: id,
                    token: token
                  }
                });
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.closeModal = function () {
      audio.onClick();
      audio.playSfx('popUpReverse', true, 1);

      _this.setState({
        isVisible: false,
        terms: false,
        showSignUpForm: false,
        showRecoverPass: _objectSpread(_objectSpread({}, _this.state.showRecoverPass), {}, {
          visible: false
        })
      });
    };

    _this.openModal = function (mountIntent) {
      audio.playSfx('popUp', true, 1);

      _this.setState({
        isVisible: true,
        terms: false,
        termsAccepted: false,
        mountIntent: mountIntent
      });
    };

    _this._loginHandler = function () {
      if (ENVIRONMENT_VARIABLES.SSO_ENABLED === 'true') {
        _this.setState({
          isLoading: true
        });

        QueryParamsProxy.navigate(_this.props.navigation, Screens.SSOLogin);
      } else {
        QueryParamsProxy.navigate(_this.props.navigation, Screens.Login);
      }
    };

    _this._ssoLoginHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var ssoLinks, destinationUrl;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.next = 3;
              return SSOLinksInterface.getSSOLinks();

            case 3:
              ssoLinks = _context2.sent;
              destinationUrl = ssoLinks[SSOLinksResponseKeys.LOGIN_URL];

              if (ENVIRONMENT_VARIABLES.SSO_DEV === 'true') {
                destinationUrl = destinationUrl.replace(new RegExp("(redirect_uri=)(.*)(/".concat(ENVIRONMENT_VARIABLES.SSO_CALLBACK_PATH, ")")), "$1".concat(document.location.origin, "$3"));
              }

              document.location = destinationUrl;

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.onStarActivate = function () {
      audio.onClick();
      _this.isRN ? _this._loginHandler() : _this._ssoLoginHandler();
    };

    _this.onAccountActivate = function () {
      audio.onClick();

      _this._loginHandler();
    };

    _this.onGuestActivate = function () {
      audio.onClick();
      var _this$state = _this.state,
          termsAccepted = _this$state.termsAccepted,
          mountIntent = _this$state.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.GUEST_LOGIN) {
        _this._guestLoginHandler();
      } else {
        _this.openModal(MOUNT_INTENTS.GUEST_LOGIN);
      }
    };

    _this.onFacebookActivate = function () {
      audio.onClick();
      var _this$state2 = _this.state,
          termsAccepted = _this$state2.termsAccepted,
          mountIntent = _this$state2.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.FACEBOOK_LOGIN) {
        _this.props.mountIntent.facebook();
      } else {
        _this.openModal(MOUNT_INTENTS.FACEBOOK_LOGIN);
      }
    };

    _this.onGoogleActivate = function () {
      audio.onClick();
      var _this$state3 = _this.state,
          termsAccepted = _this$state3.termsAccepted,
          mountIntent = _this$state3.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.GOOGLE_LOGIN) {
        _this.props.mountIntent.google();
      } else {
        _this.openModal(MOUNT_INTENTS.GOOGLE_LOGIN);
      }
    };

    _this.onAppleActivate = function () {
      audio.onClick();
      var _this$state4 = _this.state,
          termsAccepted = _this$state4.termsAccepted,
          mountIntent = _this$state4.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.APPLE_LOGIN) {
        _this.props.mountIntent.apple();
      } else {
        _this.openModal(MOUNT_INTENTS.APPLE_LOGIN);
      }
    };

    _this.setTerms = function () {
      audio.onClick();

      _this.setState({
        terms: !_this.state.terms
      });
    };

    _this.onSubmit = function () {
      audio.onClick();

      _this.setState({
        termsAccepted: true
      }, function () {
        _this.closeModal();

        switch (_this.state.mountIntent) {
          case MOUNT_INTENTS.FACEBOOK_LOGIN:
            _this.onFacebookActivate();

            break;

          case MOUNT_INTENTS.APPLE_LOGIN:
            _this.onAppleActivate();

            break;

          case MOUNT_INTENTS.GOOGLE_LOGIN:
            _this.onGoogleActivate();

            break;

          case MOUNT_INTENTS.GUEST_LOGIN:
            _this.onGuestActivate();

            break;

          default:
            break;
        }
      });
    };

    _this._guestLoginHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var aff_id;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _this.setState({
                isLoading: true
              });

              _context3.next = 4;
              return getAffId();

            case 4:
              aff_id = _context3.sent;
              _context3.next = 7;
              return store.dispatch(postGuestLogin.initiate(_objectSpread({}, aff_id && {
                aff_id: aff_id
              }))).unwrap();

            case 7:
              _context3.next = 13;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);

              _this.setState({
                isLoading: false,
                serverResponse: _context3.t0
              });

              if (typeof _context3.t0 !== String) _this.context.addNotification({
                message: _context3.t0.message || _context3.t0.data.message,
                title: getText(TEXT_KEY.TRY_AGAIN),
                button: getText(TEXT_KEY.OK)
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    _this._signupHandler = function () {
      if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'star') {
        QueryParamsProxy.navigate(_this.props.navigation, Screens.Signup);
      } else {
        audio.onClick();

        _this.setState({
          showSignUpForm: true
        });
      }
    };

    _this._cancelHandler = function () {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
    };

    _this.state = {
      isVisible: false,
      terms: false,
      socialError: false,
      isLoading: false,
      mountIntent: '',
      termsAccepted: false,
      showSignUpForm: false,
      showRecoverPass: {}
    };
    return _this;
  }

  _createClass(Start, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Utils.getPlatform() === 'web' && this.checkRecoverPassRequest();
      audio.playSfx('crowdsTalking', true, 0.7);
      var currentSrceen = this.props.navigation.state.routeName;
      audio.setCurrentScreen(currentSrceen); // if the token and restart token are present, the player is logged in and should not be able to access the start screen
      // this is used to ensure the back button does not bring players to this screen

      if (this.props.token.token !== '' && this.props.restart.token !== '') {
        audio.fadeOut('crowdsTalking');
        QueryParamsProxy.navigate(this.props.navigation, Screens.Lobby);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      audio.fadeOut('crowdsTalking');
      audio.setCurrentScreen('');
    }
  }, {
    key: "render",
    value: function render() {
      return (// Pass state and handlers to platform renderer
        this.props.token.token === '' && this.props.render({
          loginHandler: this._loginHandler,
          onGuestActivate: this.onGuestActivate,
          onFacebookActivate: this.onFacebookActivate,
          onGoogleActivate: this.onGoogleActivate,
          onAppleActivate: this.onAppleActivate,
          onAccountActivate: isStar ? this.onStarActivate : this.onAccountActivate,
          signupHandler: this._signupHandler,
          statusMessage: this.props.navigation.getParam(RouteParamConstants.PARAM_STATUS_MESSAGE),
          statusAction: this.props.navigation.getParam(RouteParamConstants.PARAM_ACTION),
          googleAuthServiceAvailable: this.props.googleAuthServiceAvailable,
          isVisible: this.state.isVisible,
          terms: this.state.terms,
          isLoading: this.state.isLoading,
          closeModal: this.closeModal,
          onSubmit: this.onSubmit,
          setTerms: this.setTerms,
          termsAndConditionsUrl: this.props.assetsUrls ? this.props.assetsUrls.termsAndConditions : '',
          privacyPolicyUrl: this.props.assetsUrls ? this.props.assetsUrls.privacyPolicy : '',
          showSignUpForm: this.state.showSignUpForm,
          recoverPasswordResponse: this.state.showRecoverPass
        })
      );
    }
  }]);

  return Start;
}(Component);

Start.contextType = NotificationContext;
export { Start as default };